export const disableBackToOriginalDimensions = element =>
  element.originalSize &&
  element.width === element.originalSize.width &&
  element.height === element.originalSize.height;
